import React from "react";
import lineChart from "./LineChart";
import { parseMessages } from "../../../utilityHelper";
import { Accordion, AccordionRow, Table, Row, Col, Card, CaptionText, BodyText, LoadingSpinner, ArrowDownIcon, ArrowUpIcon, Badge, Container } from "@paypalcorp/pp-react";
import ReactHtmlParser from 'react-html-parser';
import withTheme from "../../../common/withTheme";
const dashboardPageMsg = parseMessages("givingfund");

const SFCtile = ({ favoriteCharityLoading, favoriteCharityDataError, sfcCharityData }) => {
    const { favoriteCharityDonorCount, favoriteCharityMonthlyCount, favoriteCharityDataPercentage } = sfcCharityData;
    const favoriteCharitySinceDate = dashboardPageMsg.dashboard.sfc.sincemonthyear.replace('{SFC_MONTH_YEAR}', favoriteCharityMonthlyCount?.[0]?.date)
    const favoriteCharityTotalCount = dashboardPageMsg.dashboard.sfc.totalcountinfo.replace('{SFC_COUNT}', `<h1 class="donorCountFont"}>${favoriteCharityDonorCount?.toLocaleString()} </h1>`)
    
    return (
        <Card style={{ marginBottom: "20px" }} id="sfcCardSection">
            {favoriteCharityLoading && <LoadingSpinner size="md" />}

            {favoriteCharityDataError && <BodyText>{ReactHtmlParser(dashboardPageMsg.dashboard.sfc.error)}</BodyText>}
            {favoriteCharityDonorCount === 0 && <BodyText>{ReactHtmlParser(dashboardPageMsg.dashboard.sfc.yettoset)}</BodyText>}

            {favoriteCharityDonorCount > 0 && (<>
                <span><BodyText>{ReactHtmlParser(favoriteCharityTotalCount)}</BodyText></span>
                {favoriteCharityMonthlyCount.length > 0 && <><Card.Content>
                    {favoriteCharityMonthlyCount.length > 1 && lineChart(favoriteCharityMonthlyCount)}
                    <Container fluid={true}>
                        <Row>
                            <Col md="auto">
                                <Badge type={`${Math.sign(favoriteCharityDataPercentage?.[0]?.percentage) === -1 ? "neutral" : Math.sign(favoriteCharityDataPercentage?.[0]?.percentage) === 1 && favoriteCharityDataPercentage?.[0]?.percentage > 0 ? "success" : "feature"}`} leftIcon={Math.sign(favoriteCharityDataPercentage?.[0]?.percentage) === -1 ? ArrowDownIcon : Math.sign(favoriteCharityDataPercentage?.[0]?.percentage) === 1 ? ArrowUpIcon : null}>
                                    {Math.abs(favoriteCharityDataPercentage?.[0]?.percentage)}%
                                </Badge>
                            </Col>
                            <Col md="auto">
                                {favoriteCharityMonthlyCount?.[0]?.date && <CaptionText className="sfcSinceDate">{ReactHtmlParser(favoriteCharitySinceDate)}</CaptionText>}
                            </Col>
                            <Col xs="true" xxl={2} ></Col>
                        </Row>
                    </Container>

                </Card.Content>

                    <Accordion name="myAccordion">
                        <AccordionRow heading={ReactHtmlParser(dashboardPageMsg.dashboad.sfc.details)} headerClassName="accordianHeading">
                            <Table isFullWidth bgcolor="white" align="left">
                                <thead>
                                    <tr style={{ backgroundColor: "#fff" }}>
                                        <th>{ReactHtmlParser(dashboardPageMsg.dashboad.sfc.date)}</th>
                                        <th>{ReactHtmlParser(dashboardPageMsg.dashboad.sfc.donors)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {favoriteCharityMonthlyCount?.map((item, index) => {
                                        return (<tr key={index}><td><CaptionText className="sfcItemDate">{item.date}</CaptionText></td><td><CaptionText className="sfcItemDonor">{item.donors}</CaptionText></td></tr>)
                                    })}

                                </tbody>
                            </Table>
                        </AccordionRow>
                    </Accordion> </>}


            </>)}
        </Card>
    )
}

export default withTheme(SFCtile);